import { useEffect, useMemo } from 'react';
import omit from 'lodash/omit';

const ignoredFields = ['page', 'per_page', 'sort_by', 'sort_order'];

export const useGridResetSelectedOnFilterChange = (handleResetSelection: VoidFunction, filteredObject: Object) => {
    const filteredString = useMemo(() => JSON.stringify(omit(filteredObject, ignoredFields)), [filteredObject]);

    useEffect(() => {
        handleResetSelection();
    }, [handleResetSelection, filteredString]);
};
